import type { ButtonProps } from '@_/ui';
import { FormattedMessage } from 'react-intl';
import { buttonCommonI18n } from '@_/i18n-common';
import { Button } from '@_/ui';
import { useMutationContext } from './index.ts';

export function MutationSubmitButton({ children, ...rest }: ButtonProps) {
  const mutation = useMutationContext();

  if (!mutation) {
    throw new Error('<MutationSubmitButton> needs to be used inside <MutationProvider>');
  }

  const disabled = rest.disabled ?? mutation.isSuccess;
  const loading = rest.loading ?? mutation.isPending;

  return (
    <Button color="primary" {...rest} disabled={disabled} loading={loading}>
      {children || <FormattedMessage {...buttonCommonI18n.save} />}
    </Button>
  );
}
